import {
  UpdateXeroSettingsParams,
  XeroJournalExportResponse,
  XeroJournalPreview,
  XeroJournalRequest,
  XeroSettingsResponse,
} from '@nxsys/types/api/accounting';
import axios from '../axios';
import { endPoints } from '../endpoints';

export const getXeroSettingsApi = async (
  companyId: string,
): Promise<XeroSettingsResponse> => {
  const response = await axios.get(endPoints.company.xeroSettings(companyId));
  return response.data;
};

export const updateXeroSettingsApi = async (
  companyId: string,
  params: UpdateXeroSettingsParams,
): Promise<XeroSettingsResponse> => {
  const response = await axios.put(
    endPoints.company.xeroSettings(companyId),
    params,
  );
  return response.data;
};

export const previewXeroJournalApi = async (
  params: XeroJournalRequest,
): Promise<XeroJournalPreview> => {
  const response = await axios.post(
    endPoints.accounting.journalPreview,
    params,
  );
  return response.data;
};

export const exportXeroJournalApi = async (
  params: XeroJournalRequest,
): Promise<XeroJournalExportResponse> => {
  const response = await axios.post(endPoints.accounting.journalExport, params);
  return response.data;
};
